export default __webpack_public_path__ + "static/media/notification.35c2eaea.svg";